import { useQuery, keepPreviousData } from "@tanstack/react-query";

import {
  getRoiDashboard,
  type GetRoiDashboardParams,
} from "../../services/roiDashboard";

export type { GetRoiDashboardParams };

export function useRoiDashboard(params: GetRoiDashboardParams = {}) {
  return useQuery({
    queryKey: ["roi-dashboard", params],
    queryFn: () => getRoiDashboard(params),
    placeholderData: keepPreviousData,
  });
}
